const progressBarConfig = [
  { id: 0, circleActive: false, lineActive: false },
  { id: 1, circleActive: false, lineActive: false },
  { id: 2, circleActive: false, lineActive: false },
  { id: 3, circleActive: false, lineActive: false },
  { id: 4, circleActive: false, lineActive: false },
]

export default progressBarConfig
